import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { router } from './router';
import './index.css';

const element = document.getElementById('root');
if (!element) throw new Error('Root element #root not found in index.html');

const app = (
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);

// Under `bun --hot` the module re-evaluates; re-calling createRoot on the same
// element would warn and throw away the tree, so the root is stashed on the HMR
// data object exactly as the core-template does it.
if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(element));
  root.render(app);
} else {
  createRoot(element).render(app);
}
